module.exports = __webpack_public_path__ + "assets/img/plc_gateway.862de993.png";